module.exports = __webpack_public_path__ + "static/media/radio-selected.2a323996.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icons/radio-selected.svg
// module id = 878
// module chunks = 21